import { ACTION, CATEGORY, evt } from "fe-common/analytics/analytics";
import React from "react";
import { Link } from "@mui/material";

const setHttpToLinkIfMissing = (link: string): string => {
  if (link && !link.startsWith("http")) {
    link = `https://${link}`;
  }
  return link;
};

export function ArticleLink(props: {
  link: string;
  children?: any;
  hideUnderline?: boolean;
}) {
  const link = setHttpToLinkIfMissing(props.link);
  return (
    <Link
      href={link}
      style={{
        textDecoration: props.hideUnderline ? "none" : "underline",
        fontWeight: 500,
        fontSize: "14px",
      }}
      target="_blank"
      rel="noreferrer"
      onClick={() => {
        evt({
          category: CATEGORY.NAVIGATION,
          action: ACTION.LINK,
          label: link,
        });
      }}
    >
      {props.children}
    </Link>
  );
}
